<template>
  <div class="active">

    <!-- {{connectedFields}} -->

    <div class="--content">
      <div class="heading">
        <h1>{{$ml.get('Vultus Satellite')}}</h1>
        <app-btn :to="`/dashboard/satellite/about`">{{ $ml.get('Info') }}</app-btn>
      </div>

      <div class="available-hectares">
        <p>{{$ml.get('Available hectares')}}: <b>{{ $store.getters['user/data'].hectares }}</b></p>
        <app-btn @click="buyHectares">{{$ml.get('Buy hectares')}}</app-btn>
      </div>

      <div class="content" v-if="fields">
        <h2>{{$ml.get('Fields:')}}</h2>

        <div class="rows">
          <div class="row head" >
            <div class="col">{{$ml.get('Name')}} </div>
            <!-- <div class="col">{{$ml.get('farm')}} {{i}}</div> -->
            <div class="col">{{$ml.get('Field area, ') + $store.getters['unit/getLabel']('ha')}} </div>
            <div class="col">{{$ml.get('Status')}}</div>
          </div>
          <div class="row" v-for="field in fields" v-if="field.shape == 'polygon'">
            <div class="col name">
              <router-link :to="{name: `map-view`, params: {satellite: true, fieldId : field.id}}" >
                {{ field.name }}
              </router-link>
            </div>
            <!-- <div class="col">{{ field.area }}</div> -->
            <div class="col">{{ $store.getters['unit/convert']('ha', field.area) }}</div>
            <div class="col">
              <template v-if="field.satelliteExpirationDate">
                {{ $ml.get('Active') }}
                 ({{ moment(field.satelliteExpirationDate).format("MMM Do YYYY") }})
              </template>
              <template v-else>
                <app-btn styling="outline" :to="{name: `map-view`, params: {satellite: true, fieldId : field.id}}">
                  {{ $ml.get('Connect') }}
                </app-btn>
              </template>
              <!-- {{  ? ` ` : '-' }} -->
            </div>
          </div>
        </div>
      </div>

      <!-- <empty-content v-else :title="$ml.get('You don\'t have subscribed fields yet!')" /> -->

    </div>

    <!-- <div class="empty" v-else>
      <empty-content :title="''">
        <template v-slot:content>
          <about />
        </template>
      </empty-content>
    </div> -->

    <router-view></router-view>

  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import About from '@/views/satellite/About'
export default {
  data() {
    return {
      moment: moment,
    }
  },
  methods: {
    buyHectares() {
      this.$store.dispatch('satellite/selectField', null).then(res => {
        this.$router.push('/dashboard/satellite/active/purchase');
      })
    },
  },
  computed: {
    ...mapGetters({
      fields: 'farms/fields'
    }),
    connectedFields: function() {
      return this.fields.filter(el => el.connectedToVultus === true);
    }
  },
  components: {
    About,
  }
}
</script>

<style lang="scss" scoped>
.active {
  height: 100%;
  .heading {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    h1 {
      // margin-top: 0;
    }
  }
  .available-hectares {
    display: flex;
    align-items: center;
    .btn {
      margin-left: 16px;
    }
  }
  .--content {
    background-color: #fff;
    padding: 16px;
    box-sizing: border-box;
  }
  .rows {
    .row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 8px;
      margin-bottom: 8px;
      font-size: 18px;
      color: #333;
      padding-top: 8px;
      &.head {
        text-transform: uppercase;
        font-size: 14px;
        color: #8B8D91;
        border-bottom: 1px solid #E4E5E6;
      }
      .col {
        flex-basis: 33.33%;
        display: flex;
        &.name {
          font-weight: 500;
        }
      }
    }
  }


}
</style>
